interface ShowIconCheckboxProps {
  showIcon: boolean;
  setShowIcon: (value: boolean) => void;
}

const ShowIconCheckbox: React.FC<ShowIconCheckboxProps> = ({ showIcon, setShowIcon }) => {
  return (
    <label className='flex items-center gap-2'>
      <input type='checkbox' checked={showIcon} onChange={(e) => setShowIcon(e.target.checked)} />
      Mostrar Ícone
    </label>
  );
};

export default ShowIconCheckbox;
